<template>
  <el-dialog
    :visible="this.isVisibleDialogSaveAndExit"
    center
    class="dialog--saveAndExit"
    @close="setIsVisibleDialogSaveAndExit(false)"
  >
    <div>
      <div class="progress-label">Your progress is saved!</div>
      <progress-bar
        :hideLabel="true"
        :percentage="getTotalProgressPercentage()"
      />

      <el-row class="row--actions">
        <el-col :span="12" class="left">
          <div v-if="booking && booking.isOverCheckInDeadline">
            <div class="title">
              Please complete your check-in as soon as you can.
            </div>
            <div>
              <p>
                We need all guests' details and requests in advance so that we
                can deliver the greatest possible trip experience for you.
                Please return to complete all pending information soon.
              </p>
            </div>
          </div>
          <div v-else>
            <div class="title">
              Unable to complete your check-in process at this time?
            </div>
            <div class="">
              <p>No problem!</p>
              <p>You can return to complete your online check-in by</p>
              <p v-if="booking" class="date">
                {{ booking.checkInDeadline + "." }}
              </p>
            </div>
          </div>
          <div class="button-container">
            <el-button type="primary" @click="onClickLogout">Log out</el-button>
            <a
              class="link-contact-us"
              :href="appendMarketingSiteUrl('/contact-us')"
              target="_blank"
              >Contact us</a
            >
          </div>
        </el-col>
        <el-col :span="12" class="right">
          <div class="title">I would like to continue to check in.</div>
          <div class="button-container">
            <el-button
              type="primary"
              @click="setIsVisibleDialogSaveAndExit(false)"
              >Continue to check in
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import types from "../store/types";
import contactMixin from "../mixins/contact";
import logoutMixin from "../mixins/logout";
import ProgressBar from "./ProgressBar";

export default {
  mixins: [contactMixin, logoutMixin],
  components: { ProgressBar },
  computed: {
    ...mapGetters([
      types.getters.booking,
      types.getters.isVisibleDialogSaveAndExit,
    ]),
  },
  methods: {
    ...mapActions([types.actions.setIsVisibleDialogSaveAndExit]),
    getTotalProgressPercentage: function () {
      const data = this.getTotalProgressData();
      return (data && data.percentage) || 0;
    },
    appendMarketingSiteUrl(path) {
      return `${process.env.MARKETING_SITE_FRONTEND_URL}${path || ""}`;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/color";
@import "../scss/typography";

.el-button.btn--saveAndExit {
  margin-left: 0;
  background-color: $light-blue;
  border-color: $primary-color;
  color: $primary-color;
}

.el-button + .el-button.btn--saveAndExit {
  margin-left: auto;
}

.dialog--saveAndExit {
  .el-dialog {
    min-width: 834px;

    &__body {
      @include typo-bold(24);
    }

    &__header {
      padding: 0;
    }

    &--center {
      .el-dialog__body {
        padding: 80px 106px;
        text-align: center;
      }
    }

    &__footer {
      padding: 80px 55px;
    }
  }

  .progress-label {
    margin-bottom: 35px;
  }

  .progress {
    margin: 0 auto 41px auto;
    justify-content: center;

    &__bar {
      background-color: #ecf1f5;
    }
  }

  .el-row.row--actions {
    position: relative;
    height: 300px;

    .el-col {
      .title {
        margin-bottom: 8px;
        @include typo-bold(20);
        text-align: left;
        word-break: keep-all;
        overflow-wrap: normal;
        hyphens: none;
      }

      &.left {
        padding-right: 50px;
      }

      &.right {
        height: 100%;
        padding-left: 50px;
        border-left: 1px solid $line-color;
      }
    }

    .button-container {
      position: absolute;
      bottom: 0;
    }
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
    @include typo(18);
    text-align: left;
    word-break: keep-all;
    overflow-wrap: normal;
    hyphens: none;

    &.date {
      margin-top: 8px;
      font-weight: bold;
      color: $text-title-blue;
    }
  }

  .link-contact-us {
    padding: 18px 18px 17px;
    @include typo(16);

    &:hover {
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DialogSaveAndExit.vue